/**
 * Landing Feature - API Service
 * Raw API calls using httpClient (no React)
 *
 * Uses default endpoint type from siteConfig.defaultEndpointType
 */

import { httpClient } from "@/shared/core/clients";
import type { ContactFormRequestDTO, MailingListRequestDTO } from "../dto";

/**
 * API Endpoints
 */
const ENDPOINTS = {
  CONTACT_US: "/landing/contact_us",
  MAILING_LIST: "/landing/add_to_mailing_list",
} as const;

/**
 * Landing Page API Service
 */
export const landingApi = {
  /**
   * Submit contact form
   * @param data - Contact form data
   * @returns Success status
   */
  submitContactForm: async (data: ContactFormRequestDTO): Promise<boolean> => {
    try {
      const response = await httpClient.post(ENDPOINTS.CONTACT_US, data);
      return response.status === 202;
    } catch {
      return false;
    }
  },

  /**
   * Subscribe to mailing list
   * @param data - Email and captcha token
   * @returns Success status
   */
  subscribeToMailingList: async (
    data: MailingListRequestDTO
  ): Promise<boolean> => {
    try {
      const response = await httpClient.post(ENDPOINTS.MAILING_LIST, data);
      return response.status === 201;
    } catch {
      return false;
    }
  },
};

export default landingApi;
